import React, { useState } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
interface Column {
  key: string;
  label: string;
  sortable?: boolean;
  render?: (value: any) => React.ReactNode;
}
interface DataTableProps {
  columns: Column[];
  data: any[];
  onRowClick?: (row: any) => void;
}
const DataTable: React.FC<DataTableProps> = ({
  columns,
  data,
  onRowClick
}) => {
  const [sortColumn, setSortColumn] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const handleSort = (column: Column) => {
    if (!column.sortable) return;
    if (sortColumn === column.key) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column.key);
      setSortDirection('asc');
    }
  };
  const sortedData = [...data].sort((a, b) => {
    if (!sortColumn) return 0;
    const aValue = a[sortColumn];
    const bValue = b[sortColumn];
    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return sortDirection === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    }
    return sortDirection === 'asc' ? aValue > bValue ? 1 : -1 : aValue < bValue ? 1 : -1;
  });
  return <div className="overflow-x-auto" data-id="element-106">
      <table className="w-full" data-id="element-107">
        <thead data-id="element-108">
          <tr className="text-left text-xs text-gray-500 border-b border-gray-200" data-id="element-109">
            {columns.map(column => <th key={column.key} className={`px-4 py-3 font-medium ${column.sortable ? 'cursor-pointer' : ''}`} onClick={() => handleSort(column)} data-id="element-110">
                <div className="flex items-center" data-id="element-111">
                  {column.label}
                  {column.sortable && sortColumn === column.key && <span className="ml-1" data-id="element-112">
                      {sortDirection === 'asc' ? <ChevronUp size={14} data-id="element-113" /> : <ChevronDown size={14} data-id="element-114" />}
                    </span>}
                </div>
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-115">
          {sortedData.map((row, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer" onClick={() => onRowClick && onRowClick(row)} data-id="element-116">
              {columns.map(column => <td key={column.key} className="px-4 py-3 text-sm" data-id="element-117">
                  {column.render ? column.render(row[column.key]) : row[column.key]}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
};
export default DataTable;